//Globals
var quickShopItems = [];

(function () {
    $(document).ready(function () {
        //ANIMATE IMAGE ON MOUSEOVER
        $(".slight-zoom-container img").mouseover(function () {
            $(this).addClass("animate");
        });

        $(".slight-zoom-container img").on("animationend", function () {
            $(this).removeClass("animate");
        });
      
        /* =============================================================================
           Site Header - Drop Down Menu
           ============================================================================= */
        $("header .menu-container .menu-item").click(function(event){
          event.preventDefault();
          $(this).toggleClass("active").siblings().removeClass("active");
          
          var currentMenu = $(this).data("menu");
          $(".drop-down-menu:not(#" + currentMenu + ")").removeClass("top").addClass("bottom");
          $("#" + currentMenu).removeClass("bottom").addClass("top").stop().slideToggle(function(){
              $(".drop-down-menu:not(#" + currentMenu + ")").slideUp();
            }
          );
        });
      
        $("#MainContent").not(".menu-container .menu-item").not("a").click(function(event){
          $(".drop-down-menu").slideUp();
        });
    });
}());